<template>
  <div v-if="visible" class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
      <!-- 背景遮罩 -->
      <div 
        v-if="visible"
        class="fixed inset-0 transition-opacity"
        @click="handleClose"
      >
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <!-- 模态框内容 -->
      <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6 w-[90vw] max-w-[90vw] mx-auto">
        <!-- 标题 -->
        <div class="flex items-center justify-between mb-4">
          <div>
          <h3 class="text-lg font-medium text-gray-900">
            添加邮件账户
          </h3>
            <p class="mt-1 text-sm text-gray-500">
              配置邮件服务商信息，添加新的邮件账户
            </p>
          </div>
          <button
            @click="handleClose"
            class="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <XMarkIcon class="h-6 w-6" />
          </button>
        </div>

        <!-- 添加结果显示 -->
        <div v-if="success" class="mb-6">
          <div class="bg-green-50 border border-green-200 rounded-lg p-4">
            <div class="flex items-center">
              <CheckCircleIcon class="h-5 w-5 text-green-600 mr-2" />
              <h4 class="text-sm font-medium text-green-900">添加成功</h4>
            </div>
            <div class="mt-2 text-sm text-green-700">
              {{ successMessage }}
            </div>
          </div>
        </div>

        <div v-if="error" class="mb-6">
          <div class="bg-red-50 border border-red-200 rounded-lg p-4">
            <div class="flex items-center">
              <ExclamationTriangleIcon class="h-5 w-5 text-red-600 mr-2" />
              <h4 class="text-sm font-medium text-red-900">添加失败</h4>
            </div>
            <div class="mt-2 text-sm text-red-700">
              {{ errorMessage }}
            </div>
          </div>
        </div>

        <!-- Tab 导航 -->
        <div v-if="!success" class="border-b border-gray-200 mb-6">
          <nav class="-mb-px flex sm:space-x-8">
            <button
              v-for="tab in tabs"
              :key="tab.id"
              @click="activeTab = tab.id"
              :class="[
                'py-2 border-b-2 font-medium text-sm whitespace-nowrap flex-1 sm:flex-none sm:px-1',
                'text-center sm:text-left',
                activeTab === tab.id
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              ]"
            >
              {{ tab.name }}
            </button>
          </nav>
        </div>

        <!-- 表单内容 -->
        <div v-if="!success">
          <form @submit.prevent="handleSubmit" class="space-y-6">
            <!-- 基本信息 Tab -->
            <div v-show="activeTab === 'basic'" class="space-y-4">
            <!-- 邮箱服务提供商 -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                邮箱服务提供商 <span class="text-red-500">*</span>
              </label>
              <select
                v-model="formData.provider"
                required
                  class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200"
              >
                <option value="">请选择邮箱服务提供商</option>
                <option value="outlook">Outlook</option>
                <option value="gmail">Gmail</option>
                <option value="163">163邮箱</option>
                <option value="163vip">163VIP邮箱</option>
                <option value="aliyun">阿里云企业邮箱</option>
                <option value="custom">自定义邮箱</option>
              </select>
            </div>

              <!-- 分组选择 -->
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  所属分组
                </label>
                <SearchableSelect
                  v-model="formData.group_id"
                  :options="groupOptions"
                  placeholder="请选择分组（可选）"
                  :clearable="true"
                  class="w-full h-10"
                  style="height: 42px;"
                />
            </div>

            <!-- 邮箱地址 -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                邮箱地址 <span class="text-red-500">*</span>
              </label>
              <input
                v-model="formData.email"
                type="email"
                required
                :placeholder="getEmailPlaceholder(formData.provider)"
                  class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
              />
            </div>

            <!-- 授权密码 (非Outlook) -->
            <div v-if="formData.provider && formData.provider !== 'outlook'">
              <label class="block text-sm font-medium text-gray-700 mb-2">
                授权密码 <span class="text-red-500">*</span>
              </label>
              <input
                v-model="formData.password"
                type="password"
                required
                placeholder="请输入授权密码（非登录密码）"
                  class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
              />
              <p class="mt-1 text-xs text-gray-500">
                {{ getPasswordHint(formData.provider) }}
              </p>
            </div>

            <!-- OAuth2 说明 (Outlook) -->
            <div v-if="formData.provider === 'outlook'" class="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <div class="flex items-start">
                <div class="ml-2">
                  <p class="text-sm text-blue-700">
                    Outlook邮箱使用微软官方OAuth2认证，无需输入密码，安全可靠。
                  </p>
                </div>
              </div>
            </div>

            <!-- 自定义邮箱配置 -->
            <div v-if="formData.provider === 'custom'">
              <div class="bg-orange-50 border border-orange-200 rounded-lg p-3 mb-4">
                <div class="flex items-start">
                  <div class="ml-2">
                    <p class="text-sm text-orange-700">
                      自定义邮箱需要您手动配置IMAP和SMTP服务器信息，请确保配置信息准确无误。
                    </p>
                  </div>
                </div>
              </div>

              <!-- IMAP配置 -->
              <div class="mb-4">
                <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
                  <div class="sm:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      IMAP服务器地址 <span class="text-red-500">*</span>
                    </label>
                    <input
                      v-model="formData.imap_server"
                      type="text"
                      required
                      placeholder="例如：imap.gmail.com"
                      class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      IMAP端口 <span class="text-red-500">*</span>
                    </label>
                    <input
                      v-model="formData.imap_port"
                      type="number"
                      required
                      placeholder="993"
                      class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
                    />
                  </div>
                </div>
              </div>

              <!-- SMTP配置 -->
              <div>
                <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
                  <div class="sm:col-span-2">
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      SMTP服务器地址 <span class="text-red-500">*</span>
                    </label>
                    <input
                      v-model="formData.smtp_server"
                      type="text"
                      required
                      placeholder="例如：smtp.gmail.com"
                      class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">
                      SMTP端口 <span class="text-red-500">*</span>
                    </label>
                    <input
                      v-model="formData.smtp_port"
                      type="number"
                      required
                      placeholder="587"
                      class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- 显示名称 -->
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                显示名称
              </label>
              <input
                v-model="formData.display_name"
                type="text"
                placeholder="可选，用于显示的账户名称"
                  class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
                />
              </div>
            </div>

            <!-- 自定义字段 Tab -->
            <div v-show="activeTab === 'custom'" class="space-y-4">
              <div v-if="customFields.length === 0" class="text-center py-8 text-gray-500">
                暂无自定义字段
              </div>
              <div v-else class="space-y-4">
                <div v-for="field in customFields" :key="field.id">
                  <label class="block text-sm font-medium text-gray-700 mb-2">
                    {{ field.label }}
                    <span v-if="field.is_required" class="text-red-500">*</span>
                  </label>

                  <!-- 文本输入 -->
                  <input
                    v-if="field.field_type === 'text'"
                    v-model="customFieldValues[field.name]"
                    type="text"
                    :placeholder="field.placeholder"
                    :required="field.is_required"
                    class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
                  />

                  <!-- 多行文本 -->
                  <textarea
                    v-else-if="field.field_type === 'textarea'"
                    v-model="customFieldValues[field.name]"
                    :placeholder="field.placeholder"
                    :required="field.is_required"
                    rows="3"
                    class="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
                  ></textarea>

                  <!-- 数字输入 -->
                  <input
                    v-else-if="field.field_type === 'number'"
                    v-model.number="customFieldValues[field.name]"
                    type="number"
                    :placeholder="field.placeholder"
                    :required="field.is_required"
                    class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
                  />

                  <!-- 小数输入 -->
                  <input
                    v-else-if="field.field_type === 'decimal'"
                    v-model.number="customFieldValues[field.name]"
                    type="number"
                    step="0.01"
                    :placeholder="field.placeholder"
                    :required="field.is_required"
                    class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
                  />

                  <!-- 日期输入 -->
                  <input
                    v-else-if="field.field_type === 'date'"
                    v-model="customFieldValues[field.name]"
                    type="date"
                    :required="field.is_required"
                    class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200"
                  />

                  <!-- 布尔值 -->
                  <div v-else-if="field.field_type === 'boolean'" class="flex items-center">
                    <input
                      v-model="customFieldValues[field.name]"
                      type="checkbox"
                      class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <span class="ml-2 text-sm text-gray-600">{{ field.help_text || '是' }}</span>
                  </div>

                  <!-- 单选 -->
                  <select
                    v-else-if="field.field_type === 'choice'"
                    v-model="customFieldValues[field.name]"
                    :required="field.is_required"
                    class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">请选择</option>
                    <option v-for="choice in field.choices" :key="choice.value" :value="choice.value">
                      {{ choice.label }}
                    </option>
                  </select>

                  <!-- 多选 -->
                  <div v-else-if="field.field_type === 'multiple_choice'" class="space-y-2">
                    <label v-for="choice in field.choices" :key="choice.value" class="flex items-center">
                      <input
                        v-model="customFieldValues[field.name]"
                        type="checkbox"
                        :value="choice.value"
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <span class="ml-2 text-sm text-gray-700">{{ choice.label }}</span>
                    </label>
                  </div>

                  <!-- 网址输入 -->
                  <input
                    v-else-if="field.field_type === 'url'"
                    v-model="customFieldValues[field.name]"
                    type="url"
                    :placeholder="field.placeholder"
                    :required="field.is_required"
                    class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
                  />

                  <!-- 邮箱输入 -->
                  <input
                    v-else-if="field.field_type === 'email'"
                    v-model="customFieldValues[field.name]"
                    type="email"
                    :placeholder="field.placeholder"
                    :required="field.is_required"
                    class="w-full h-10 px-3 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
                  />

                  <!-- 帮助文本 -->
                  <p v-if="field.help_text" class="mt-1 text-xs text-gray-500">
                    {{ field.help_text }}
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- 底部按钮 -->
        <div class="flex items-center justify-end space-x-3 mt-6">
          <button
            @click="handleClose"
            :disabled="loading"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
          >
            {{ success ? '完成' : '取消' }}
          </button>
          <button
            v-if="!success"
            @click="handleSubmit"
            :disabled="!isFormValid || loading"
            class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 flex items-center space-x-2"
          >
            <svg v-if="loading" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 714 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span>{{ loading ? '添加中...' : (formData.provider === 'outlook' ? '开始OAuth认证' : '添加账户') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { XMarkIcon, CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
import { useToast } from 'vue-toastification'
import emailAccountService from '@/services/emailAccountService'
import api from '@/utils/api'
import SearchableSelect from '@/components/common/SearchableSelect.vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  groups: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['close', 'success'])

const toast = useToast()

// 响应式数据
const loading = ref(false)
const success = ref(false)
const error = ref(false)
const successMessage = ref('')
const errorMessage = ref('')
const activeTab = ref('basic')

const formData = ref({
  provider: '',
  email: '',
  password: '',
  display_name: '',
  group_id: null,
  // 自定义邮箱IMAP配置
  imap_server: '',
  imap_port: 993,
  imap_use_ssl: true,
  // 自定义邮箱SMTP配置
  smtp_server: '',
  smtp_port: 587,
  smtp_use_tls: true
})

// 自定义字段相关
const customFields = ref([])
const customFieldValues = ref({})

// 分组相关
const groups = ref([])

// 验证自定义字段
const validateCustomFields = () => {
  for (const field of customFields.value) {
    if (field.is_required) {
      const value = customFieldValues.value[field.name]
      
      // 检查是否为空值
      if (value === undefined || value === null || value === '') {
        return `请填写必填字段: ${field.label}`
      }
      
      // 检查多选字段是否为空数组
      if (field.field_type === 'multiple_choice' && Array.isArray(value) && value.length === 0) {
        return `请选择必填字段: ${field.label}`
      }
    }
  }
  return null
}

// 计算属性
const isFormValid = computed(() => {
  // 基本字段验证
  if (!formData.value.provider || !formData.value.email.trim()) {
    return false
  }
  if (formData.value.provider !== 'outlook' && formData.value.provider !== 'custom' && !formData.value.password.trim()) {
    return false
  }
  
  // 自定义邮箱配置验证
  if (formData.value.provider === 'custom') {
    if (!formData.value.password.trim()) {
      return false
    }
    if (!formData.value.imap_server.trim() || !formData.value.imap_port) {
      return false
    }
    if (!formData.value.smtp_server.trim() || !formData.value.smtp_port) {
      return false
    }
  }
  
  // 自定义字段验证
  const customFieldError = validateCustomFields()
  if (customFieldError) {
    return false
  }
  
    return true
})

// 计算属性：是否有自定义字段
const hasCustomFields = computed(() => {
  return customFields.value.length > 0
})

// Tab配置 - 动态计算
const tabs = computed(() => {
  const baseTabs = [
    { id: 'basic', name: '基本信息' }
  ]
  
  if (hasCustomFields.value) {
    baseTabs.push({ id: 'custom', name: '自定义字段' })
  }
  
  return baseTabs
})

// 方法


// 收集自定义字段数据
const collectCustomFieldData = () => {
  const customFieldData = []
  customFields.value.forEach(field => {
    const value = customFieldValues.value[field.name]
    if (value !== undefined && value !== null && value !== '') {
      if (field.field_type === 'multiple_choice' && Array.isArray(value)) {
        // 多选字段：将数组转换为JSON字符串
        if (value.length > 0) {
          customFieldData.push({
            field_id: field.id,
            field_name: field.name,
            value: JSON.stringify(value)
          })
        }
      } else {
        // 其他字段类型
        customFieldData.push({
          field_id: field.id,
          field_name: field.name,
          value: String(value)
        })
      }
    }
  })
  return customFieldData
}

const handleSubmit = () => {
  // 验证自定义字段
  const customFieldError = validateCustomFields()
  if (customFieldError) {
    toast.error(customFieldError)
    return
  }
  
  if (formData.value.provider === 'outlook') {
    handleOutlookOAuth()
  } else {
    handlePasswordAuth()
  }
}

const handleOutlookOAuth = async () => {
  loading.value = true
  error.value = false

  try {
    const customFieldData = collectCustomFieldData()
    const submitData = {
      email: formData.value.email,
      display_name: formData.value.display_name || formData.value.email
    }

    // 如果选择了分组，包含在提交数据中
    if (formData.value.group_id) {
      submitData.group_id = formData.value.group_id
    }

    // 如果有自定义字段数据，包含在提交数据中
    if (customFieldData.length > 0) {
      submitData.custom_field_values = customFieldData
    }

    const response = await api.post('/api/microsoft-oauth/auth/init/', submitData)

    if (response.data.success && response.data.auth_url) {
      // 直接跳转到Microsoft授权页面
      window.location.href = response.data.auth_url
    } else {
      loading.value = false
      error.value = true
      errorMessage.value = response.data.message || '启动OAuth认证失败'
    }
    
  } catch (error) {
    console.error('OAuth认证失败:', error)
    loading.value = false
    error.value = true
    
    // 🔧 统一错误信息提取逻辑
    const errorData = error.response?.data || {}
    let errorMsg = '网络错误，请稍后重试'
    
    if (errorData.non_field_errors && errorData.non_field_errors.length > 0) {
      errorMsg = errorData.non_field_errors[0]
    } else if (errorData.message) {
      errorMsg = errorData.message
    } else if (errorData.error) {
      errorMsg = errorData.error
    } else if (error.message) {
      errorMsg = error.message
    }
    
    errorMessage.value = errorMsg
    // 🔧 显示toast错误提示
    toast.error(errorMsg)
  }
}

const handlePasswordAuth = async () => {
  loading.value = true
  error.value = false

  try {
    const customFieldData = collectCustomFieldData()
    const submitData = {
      email: formData.value.email,
      password: formData.value.password,
      provider: formData.value.provider,
      display_name: formData.value.display_name || formData.value.email
    }

    // 如果是自定义邮箱，包含IMAP/SMTP配置
    if (formData.value.provider === 'custom') {
      submitData.imap_server = formData.value.imap_server
      submitData.imap_port = formData.value.imap_port
      submitData.imap_use_ssl = formData.value.imap_use_ssl
      submitData.smtp_server = formData.value.smtp_server
      submitData.smtp_port = formData.value.smtp_port
      submitData.smtp_use_tls = formData.value.smtp_use_tls
    }

    // 如果选择了分组，包含在提交数据中
    if (formData.value.group_id) {
      submitData.group_id = formData.value.group_id
    }

    // 如果有自定义字段数据，包含在提交数据中
    if (customFieldData.length > 0) {
      submitData.custom_field_values = customFieldData
    }

    const result = await emailAccountService.createEmailAccount(submitData)

    loading.value = false
    success.value = true
    successMessage.value = `${formData.value.email} 已成功添加！`
    
    // 🔧 显示成功toast提示
    toast.success(successMessage.value)
    
    setTimeout(() => {
      emit('success')
      handleClose()
    }, 2000)
    
  } catch (error) {
    console.error('添加账户失败:', error)
    loading.value = false
    error.value = true
    
    // 🔧 优先提取non_field_errors中的错误信息（配额限制等）
    const errorData = error.response?.data || {}
    let errorMsg = '添加邮件账户失败，请检查邮箱地址和授权密码'
    
    if (errorData.non_field_errors && errorData.non_field_errors.length > 0) {
      errorMsg = errorData.non_field_errors[0]
    } else if (errorData.message) {
      errorMsg = errorData.message
    } else if (errorData.error) {
      errorMsg = errorData.error
    } else if (errorData.email && errorData.email.length > 0) {
      errorMsg = errorData.email[0]
    }
    
    errorMessage.value = errorMsg
    // 🔧 显示toast错误提示
    toast.error(errorMsg)
  }
}

// 加载自定义字段
const loadCustomFields = async () => {
  try {
    const response = await emailAccountService.getCustomFields({
      is_active: true,
      page_size: 100
    })
    if (response.success && response.data.results) {
      customFields.value = response.data.results
      resetCustomFieldValues()
    }
  } catch (error) {
    console.error('加载自定义字段失败:', error)
  }
}

// 加载分组（优先使用props数据，避免重复请求）
const loadGroups = async () => {
  try {
    // 如果父组件传递了分组数据，直接使用
    if (props.groups && props.groups.length > 0) {
      groups.value = [...props.groups]
      return
    }
    
    // 否则发起API请求
    const response = await emailAccountService.getEmailAccountGroups({
      page_size: 100
    })
    if (response.success && response.data.results) {
      groups.value = response.data.results
    }
  } catch (error) {
    console.error('加载分组失败:', error)
  }
}

// 分组选项计算属性
const groupOptions = computed(() => {
  return [
    { value: null, label: '无分组' },
    ...groups.value.map(group => ({
      value: group.id,
      label: group.name,
      description: group.description
    }))
  ]
})

// 重置自定义字段值为默认值
const resetCustomFieldValues = () => {
  customFields.value.forEach(field => {
    if (field.field_type === 'boolean') {
      customFieldValues.value[field.name] = field.default_value === 'true' || field.default_value === true
    } else if (field.field_type === 'multiple_choice') {
      customFieldValues.value[field.name] = []
    } else {
      customFieldValues.value[field.name] = field.default_value || ''
    }
  })
}

const handleClose = () => {
  // 重置所有状态
  loading.value = false
  success.value = false
  error.value = false
  activeTab.value = 'basic'
  formData.value = {
    provider: '',
    email: '',
    password: '',
    display_name: '',
    group_id: null,
    // 重置自定义邮箱IMAP配置
    imap_server: '',
    imap_port: 993,
    imap_use_ssl: true,
    // 重置自定义邮箱SMTP配置
    smtp_server: '',
    smtp_port: 587,
    smtp_use_tls: true
  }
  resetCustomFieldValues()
  
  emit('close')
}

// 监听弹窗显示/隐藏
watch(() => props.visible, async (newValue) => {
  if (newValue) {
    // 弹窗打开时，加载自定义字段和分组
    activeTab.value = 'basic'
    await Promise.all([
      loadCustomFields(),
      loadGroups()
    ])
  } else {
    handleClose()
  }
})

// 监听父组件传递的分组数据变化
watch(() => props.groups, (newGroups) => {
  if (newGroups && newGroups.length > 0) {
    groups.value = [...newGroups]
  }
}, { immediate: true })

// 组件挂载时只需要加载自定义字段（分组通过props传递，不需要重复请求）
onMounted(() => {
  loadCustomFields()
})

// 工具方法
const getEmailPlaceholder = (provider) => {
  switch (provider) {
    case 'outlook':
      return '例如：user@outlook.com'
    case 'gmail':
      return '例如：user@gmail.com'
    case '163':
      return '例如：user@163.com'
    case '163vip':
      return '例如：user@vip.163.com'
    case 'aliyun':
      return '例如：user@company.com'
    case 'custom':
      return '请输入完整的邮箱地址'
    default:
      return '请输入邮箱地址'
  }
}

const getPasswordHint = (provider) => {
  switch (provider) {
    case 'gmail':
      return '请使用Gmail应用专用密码（App Password），需先开启两步验证后生成'
    case '163':
    case '163vip':
      return '请使用163邮箱的授权码，而非登录密码'
    case 'aliyun':
      return '请使用阿里云企业邮箱的授权码或专用密码'
    case 'custom':
      return '请输入邮箱的授权码或专用密码'
    default:
      return '请输入邮箱的授权码'
  }
}
</script>